/**
 * Created by ZhangJunPeng on 2017/5/23.
 */


import React from 'react';
import moment from 'moment';
import { routerRedux } from 'dva/router';
import { defineMessages } from 'react-intl';
import ReservationDialog from '../commons/ReservationDialog';
import PromptInfo from '../../utils/promptInfo';
import { MAINTAIN_STATUS, PATHS, ROLES_KEY } from '../../utils/constants';
import PropTypes from 'prop-types';

const DialogType = PromptInfo.DialogType;

const messages = defineMessages({
  roomClose: {
    id: 'search_room_close'
  }
});

class DayTimeDiv extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.checkTimeUsed = this.checkTimeUsed.bind(this);
    this._user = JSON.parse(sessionStorage.getItem('userInfo'));
    this.state = {
      roomClose: false,
      isSelect: false,
      roomUsed: false
    };
  }

  componentDidMount() {
    this.checkRoomStatus();
  }

  handleClick(roomOpen, selected) {
    if (!roomOpen || this.state.roomUsed) {
      const { intl, locale } = this.props;
      ReservationDialog({
        type: DialogType.INFORMATION,
        message: intl.formatMessage(messages.roomClose),
        locale: locale
      });
      return;
    }
    const { time, dispatch, room } = this.props;
    let beginAt = time;
    let endAt = moment(time).add(15, 'minutes');
    if (selected.length === 1) {
      // 单击时间块
      let timeStr = selected[0].split('');
      const side = Number(timeStr.pop());
      const hourBlock = Number(timeStr.join(''));
      const hour = parseInt(hourBlock/2);
      const leftMin = (hourBlock - hour*2) *30;
      beginAt = moment(time)
        .hour(hour)
        .minute(side * 15 + leftMin);
      endAt = moment(time)
        .hour(hour)
        .minute(side * 15 + 15 + leftMin);
    } else {
      // 拖选时间块
      selected.sort((x, y) => {
        if (Number(x) < Number(y)) {
          return -1;
        } else if (Number(x) > Number(y)) {
          return 1;
        } else {
          return 0;
        }
      });
      // 第一个时间块
      let firstStr = selected.shift().split('');
      const startSide = Number(firstStr.pop());
      const startHourBlock = Number(firstStr.join(''));
      const startHour = parseInt(startHourBlock/2);
      const startLeftMin = (startHourBlock - startHour*2) *30;
      // 最后一个时间块
      let lastStr = selected.pop().split('');
      const endSide = Number(lastStr.pop());
      const endHourBlock = Number(lastStr.join(''));
      const endHour = parseInt(endHourBlock/2);
      const endLeftMin = (endHourBlock - endHour*2) *30;

      beginAt = moment(time)
        .hour(startHour)
        .minute(startSide * 15 + startLeftMin);
      endAt = moment(time)
        .hour(endHour)
        .minute((1 - endSide) * 15 + endLeftMin + (endSide * 30));
    }
    if (!moment(beginAt).isSame(endAt, 'day')) {
      endAt = moment(endAt).subtract(1, 'minutes');
    }
    const roomInfo = { time, room, beginAt, endAt };
    dispatch({ type: 'meetingInfo/updateRoomInfo', payload: roomInfo });
    dispatch(routerRedux.push(PATHS.meetingInfo));
  }

  checkTimeUsed() {
    const { room, time } = this.props;
    const used = room.meetings.find(v => {
      return time.valueOf() > v.startTime && time.valueOf() < v.endTime;
    });
    if (used) {
      this.setState({ roomUsed: true });
    }
  }

  checkRoomStatus = () =>{
    const { searchResults, time, room, holidays = [] } = this.props;
    const dateStr = time.format('YYYY-MM-DD');
    const isHoliday = holidays.some(x => x.dayTimeFormat == dateStr);
    const days = searchResults.data.day.replace('7', '0');
    let roomTime = days.indexOf(time.day()) !== -1;
    //为了满足开始时间等于结束时间等于00:00全天可预约专门增加的坑
    if (roomTime) {
      let end = searchResults.data.endTime;
      if (searchResults.data.startTime === '00:00' && end === '00:00') {
        end = '23:59';
      }
      const dayTime = time.format('HH:mm');
      roomTime = dayTime >= searchResults.data.startTime && dayTime < end;
    }
    /**
     * 判断是否是过去的时间，超过15分钟就禁用
     */
      // 0-没有过期 1-过期不到15分钟 2-完全过期
    let passedHour = 0, isNow = false;
    const today = moment().startOf('day');
    if (time.isBefore(today)) {
      passedHour = 2;
    } else if (time.format('YYYY-MM-DD') === today.format('YYYY-MM-DD')) {
      if (time.hour() < moment().hour()) {
        passedHour = 2;
      } else if (time.hour() === moment().hour()) {
        isNow = true;
        if(0 == time.minutes()) {
           if(moment().minutes() <= 15){
             passedHour = 1;
           } else if(moment().minutes() >= 15){
             passedHour = 2;
           }
        } else {
          if((moment().minutes() < 45) && (moment().minutes() >= 30)){
            passedHour = 1;
          } else if(moment().minutes() >= 45){
            passedHour = 2;
          }
        }
      }
    }

    const roomStatus = room.open === 0 && room.status === 0;
    const userStatus =
      room.open === 1 && this._user.roleKey === ROLES_KEY.room_admin;
    let passRight = false;
    if (MAINTAIN_STATUS.not_set !== room.maintainStatus && room.startMaintainTime && room.endMaintainTime && passedHour < 2) {
      const startMoment = moment(time);
      const halfMoment = moment(time).add(15, 'minutes');
      const endMoment = moment(time).add(30, 'minutes');

      if (moment(room.startMaintainTime).isBefore(halfMoment) && moment(room.endMaintainTime).isAfter(halfMoment)) {
        passedHour = 2;
      } else if (moment(room.startMaintainTime).isBefore(halfMoment) && moment(room.endMaintainTime).isAfter(startMoment)) {
        passedHour = 1;
      } else if (moment(room.startMaintainTime).isBefore(endMoment) && moment(room.endMaintainTime).isAfter(endMoment)) {
        passRight = true;
      }

    }
    return {
      roomOpen: roomTime && (roomStatus || userStatus),
      passedHour,
      isHoliday,
      passRight,
      isNow
    };
  }

  render() {
    const { roomOpen, passedHour, isHoliday, isNow, passRight } = this.checkRoomStatus();
    const { mouseDown, enter, time, selected, liWidth } = this.props;
    if (!roomOpen || passedHour > 1 || isHoliday) {
      return (
        <li
          className="not_available"
          style={{ width: `${liWidth/2}px` }}
          onMouseUp={() => {
            selected.length > 0 && this.handleClick(roomOpen, selected);
          }}
          id={isNow ? "current-hour-li" : ""}
        >
          {!roomOpen && <i className="iconfont icon-x" />}
        </li>
      );
    } else {
      // 用0和1区分左右时间块，在后续逻辑中方便moment对象操作
      const hasL = selected.some(i => Number(i) === Number(`${(time.hour()*2 + time.minutes()/30)}0`));
      const hasR = selected.some(i => Number(i) === Number(`${(time.hour()*2 + time.minutes()/30)}1`));
      return (
        <li style={{ width: `${liWidth/2}px` }} id={isNow ? "current-hour-li" : ""}>
          <span
            className={`half_left ${passedHour === 1 ? 'passed_hour ' : ''}${
              hasL ? 'half_selected' : ''
            }`}
            onMouseUp={() => {
              selected.length > 0 && this.handleClick(roomOpen, selected);
            }}
            onMouseDown={e => {
              e.stopPropagation();
              e.preventDefault();
              e.persist();
              passedHour === 0 && mouseDown(`${(time.hour()*2 + time.minutes()/30)}0`);
            }}
            onMouseOver={e => {
              e.stopPropagation();
              e.preventDefault();
              e.persist();
              passedHour === 0 && enter(`${(time.hour()*2 + time.minutes()/30)}0`);
            }}
          />
          <span
            className={`half_right ${passRight ? 'passed_hour ' : ''}${
              hasR ? 'half_selected' : ''
            }`}
            onMouseUp={() => {
              selected.length > 0 && this.handleClick(roomOpen, selected);
            }}
            onMouseDown={e => {
              e.stopPropagation();
              e.preventDefault();
              e.persist();
              !passRight && mouseDown(`${(time.hour()*2 + time.minutes()/30)}1`);
            }}
            onMouseOver={e => {
              e.stopPropagation();
              e.preventDefault();
              e.persist();
              !passRight && enter(`${(time.hour()*2 + time.minutes()/30)}1`);
            }}
          />
        </li>
      );
    }
  }
}

DayTimeDiv.propTypes = {
  room: PropTypes.object.isRequired,
  time: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired
};

export default DayTimeDiv;



// WEBPACK FOOTER //
// ./src/components/meeting/DayTimeDiv.js